import { homeServicesConfig as homeServices } from 'reaxl-home-services';

const fillDynamicValues = (content, replacements = {}) => Object.keys(replacements).reduce((string, key) => string.replace(`%${key}%`, replacements[key]), content);

export const getMoneyBackGuaranteeContent = ({ days, miles, hasMoneyBackGuarantee, hasVehicleReturnPolicy }) => {
    if (hasMoneyBackGuarantee && hasVehicleReturnPolicy) return fillDynamicValues(homeServices.moneyBackGuarantee.contentMoneyBackAndExchange, { days, miles });
    if (hasMoneyBackGuarantee) return fillDynamicValues(homeServices.moneyBackGuarantee.contentMoneyBackReturn, { days, miles });
    if (hasVehicleReturnPolicy) return fillDynamicValues(homeServices.moneyBackGuarantee.contentExchangePolicy, { days, miles });
    return homeServices.moneyBackGuarantee.contentDefault;
};
